import { render, staticRenderFns } from "./RemarkSection.vue?vue&type=template&id=9e0fd3ac&scoped=true"
import script from "./RemarkSection.vue?vue&type=script&lang=js"
export * from "./RemarkSection.vue?vue&type=script&lang=js"
import style0 from "./RemarkSection.vue?vue&type=style&index=0&id=9e0fd3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0fd3ac",
  null
  
)

export default component.exports